import React, { useState } from "react";
import Modal from "react-modal";
import { FaExternalLinkAlt, FaPrint, FaTimes } from "react-icons/fa";
import { AiOutlineExpand } from "react-icons/ai";
import { CSButton } from "@cadenza/ui";
import { usePrintRADComponent } from "@cadenza/ui-hooks"; // updated hook below
import "../../styles/RAD.printsvg.css";

const BigRAD = ({ Component, componentProps }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [zoomApi, setZoomApi] = useState(null);

  // Hook: keep it simple; no onBeforePrint here
  const [componentRef, printComponent] = usePrintRADComponent({
    title: document.title,
  });

  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);

  const handlePrint = printComponent;

  return (
    <div className="right-button-container">
      <CSButton onClick={openModal}>
        <FaExternalLinkAlt className="cs-icon" title="Show print screen" />
      </CSButton>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Expanded View"
        appElement={document.getElementById("root")}
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <div className="big-picture">
          <div className="right-button-container">
            <div className="right-buttons">
              <CSButton onClick={() => zoomApi?.zoomToFit?.()}>
                <AiOutlineExpand className="cs-icon" title="Fit" />
              </CSButton>
              <CSButton onClick={handlePrint}>
                <FaPrint className="cs-icon" title="Print" />
              </CSButton>
              <CSButton onClick={closeModal}>
                <FaTimes className="cs-icon" title="Close" />
              </CSButton>
            </div>
          </div>

          {/* We own this wrapper; PrintableDiagram doesn't need a ref */}
          <div ref={componentRef}>
            <Component
              {...componentProps}
              viewBoxWidth={1500}
              viewBoxHeight={1500}
              dragEnabled={false} // disable edit/drag in Big view
              onZoomApi={setZoomApi} // capture zoom API for fit-to-page
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default BigRAD;
